export function decodeBase64State(
	input: string | null,
): { keyId: string; url: string } | null {
	if (input == null) {
		return null
	}

	try {
		const decodedString = window.atob(input)
		const stateObject = JSON.parse(decodedString)

		const keyId = stateObject.keyId || stateObject.KeyId
		const url = stateObject.url || stateObject.Url

		if (typeof keyId === 'string' && typeof url === 'string') {
			return { keyId, url }
		}

		if (stateObject !== null) {
			if (
				typeof stateObject.keyId === 'string' &&
				typeof stateObject.url === 'string'
			) {
			} else {
				throw new Error('Could not parse base64 state')
			}
		}
		return stateObject
	} catch (err) {
		return null
	}
}
